import React from "react";

const inputStyle: React.CSSProperties = {
  padding: "0.75rem",
  border: "1px solid var(--color-border)",
  borderRadius: "var(--radius)",
  backgroundColor: "var(--color-surface)",
  color: "var(--color-text)",
  fontSize: "var(--font-body)",
  width: "100%",
  boxSizing: "border-box",
};

const labelStyle: React.CSSProperties = {
  marginBottom: "0.5rem",
  fontWeight: "600",
  display: "block",
};

export interface ModalDateFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  min?: string;
  max?: string;
  id?: string;
  /** Optional style for the wrapper div (e.g. flex/grid sizing), zoals ModalNumberField. */
  wrapperStyle?: React.CSSProperties;
  disabled?: boolean;
}

export function ModalDateField({
  label,
  value,
  onChange,
  required,
  min,
  max,
  id,
  wrapperStyle,
  disabled,
}: ModalDateFieldProps) {
  const fieldId = id || `modal-date-${label.replace(/\s/g, "-")}`;

  return (
    <div className="modal-field" style={wrapperStyle}>
      <label htmlFor={fieldId} style={labelStyle}>
        {label}
        {required && " *"}
      </label>
      <input
        id={fieldId}
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        min={min}
        max={max}
        disabled={disabled}
        style={inputStyle}
      />
    </div>
  );
}
